import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-task-type';
const API_DETAIL = (id: number) => `/p-crm-task-type/${id}`;

export interface TaskType {
  id: number;
  tt_descr?: string;
}

export const useTaskTypes = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<TaskType[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    taskTypes: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useTaskType = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<TaskType>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    taskType: data,
    isLoading,
    isError: error,
    mutate,
  };
};

